import { MenuItem, Popover } from "@mui/material"
import Box from "@mui/material/Box"

import styles from "./styles"
interface Column {
  headerName: string
  field?: string
  color?: string
  action?: () => void
}
interface ColumnOptionsProps {
  open: boolean
  anchorEl: null | HTMLElement
  onClose: () => void
  options: Column[]
}

export default function PopperMenu({
  open,
  anchorEl,
  onClose,
  options
}: ColumnOptionsProps) {
  return (
    <Popover
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "center",
        horizontal: "left"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      sx={{
        "& > *": {
          borderRadius: 2,
          boxShadow: "none!important",
          border: "1px solid #ccc"
        }
      }}
    >
      <Box sx={{ boxShadow: 1 }}>
        {options.map((cl, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              cl.action?.()
              onClose()
            }}
            sx={{ color: cl.color, ...styles.popOverOption }}
          >
            {cl.headerName}
          </MenuItem>
        ))}
      </Box>
    </Popover>
  )
}
